import { css } from 'styled-components';

interface GetVideoPositionOnFillVideoProps {
  $videoBackgroundPosition?: string;
  $sectionHeight?: number;
  $height?: number;
  $isFillVideo?: boolean;
  $isMobile?: boolean;
}

enum Sides {
  TOP = 'top',
  BOTTOM = 'bottom',
  LEFT = 'left',
  RIGHT = 'right',
}

// TODO To refacto when min-height is removed
const handleTopValueOnFill = ({
  $height,
  $sectionHeight,
  $videoBackgroundPosition,
  $isMobile,
}) => {
  if ($videoBackgroundPosition === 'bottom') return 'unset';
  if (
    $videoBackgroundPosition === 'top' ||
    $isMobile ||
    (!!$sectionHeight && !!$height && $sectionHeight > $height)
  )
    return '0';
  if (!!$sectionHeight && !!$height && $sectionHeight < $height) {
    return '-80%';
  }

  return '-50%';
};

export const getVideoPositionOnFillVideo = ({
  $videoBackgroundPosition,
  $sectionHeight,
  $height,
  $isMobile,
  $isFillVideo,
}: GetVideoPositionOnFillVideoProps) =>
  $isFillVideo &&
  css`
    top: ${handleTopValueOnFill({
      $videoBackgroundPosition,
      $sectionHeight,
      $height,
      $isMobile,
    })};
    bottom: ${$videoBackgroundPosition === 'bottom' && 0};
  `;

export const getVideoPositionOnFitVideo = ({
  $videoBackgroundPosition,
}: {
  $videoBackgroundPosition?: string;
}) =>
  css`
    width: 100%;
    display: flex;
    justify-content: ${handleJustifyValueOnFit($videoBackgroundPosition)};
    align-items: ${handleAlignValueOnFit($videoBackgroundPosition)};
  `;

const handleJustifyValueOnFit = (key?: string) => {
  if (key?.includes(Sides.LEFT) || key?.includes(Sides.RIGHT)) {
    return key?.includes(Sides.LEFT) ? 'left' : 'right';
  }
  if (key?.includes(Sides.TOP) || key?.includes(Sides.BOTTOM)) {
    return 'center';
  }

  return key;
};

const handleAlignValueOnFit = (value) => {
  if (value?.includes(Sides.BOTTOM) || value?.includes(Sides.TOP)) {
    return value?.includes(Sides.TOP) ? 'flex-start' : 'flex-end';
  }

  return 'center';
};
